import React from 'react'
import Mobile_data from './Mobile_data';
import { useDispatch } from 'react-redux';
import { addItem } from '../redux/slice/cartSlice';

const Card = () => {
  const dispatch = useDispatch();
  return (
    <div className='container-fluid'>
      <div className='row Card_con'>
        <div className='col-10 card_container'>
          {
            Mobile_data.map((ele) => {
              return (
                <div className='row row3'>
                  <div className='col-4'>
                    <img src={ele.img} className='img-fluid' />
                  </div>
                  <div className='col-4 product_section '>
                    <p className='name' >{ele.name}</p>
                    <p className='color'>{ele.color}</p>
                    <p className='price'>₹{ele.price}</p>

                  </div>
                  <div className='col-4  '>
                    <button className=' btn btn-primary'
                      onClick={() => dispatch(addItem({
                        img: ele.img, name: ele.name, color: ele.color, price: ele.price
                      }))}
                    >Add Cart</button>
                  </div>
                </div>
              )
            })
          }
        </div>

      </div>
    </div >
  )
}

export default Card;